


























































import { Component, Prop, Model, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { ToggleOptions, ToggleOption } from './types';

const cssPrefix: string = 'sw-group-toggle';

/**
 * Controlled form toggle group
 *
 * @event change
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwGroupToggle extends SwExtendedVue {
  @Model('change', { type: String, required: true })
  value: string;

  @Prop({ type: String, required: true })
  name: string;

  @Prop({ required: true, type: Array })
  options: ToggleOptions;

  cssPrefix: string = cssPrefix;

  hasSelected(option: ToggleOption): boolean {
    return option.id === this.value;
  }

  handleToggle(option: ToggleOption) {
    this.$emit('change', option.id);
  }

  handleClick() {}

  @Watch('options', { deep: true })
  @Watch('value')
  reconcile() {
    /** if we found the desired value doesn't exist in provided options, we request changing the value to
     * the one existing.
     */
    const found = !this.options.every(option => (option.id !== this.value));
    if (!found && this.options.length > 0) {
      this.$emit('change', this.options[0].id);
    }
  }

  created() {
    this.reconcile();
  }
}
